// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Scsp","large":"styles_large__1bSAl"};